// extracted by mini-css-extract-plugin
export var content = "_rb-1";
export var fullScreen = "_rb-0";